import request from '@/utils/request'

// export function getcategoryList(params) { // 分类列表
//     return request({
//         url: '/backend/business-school/category/list',
//         method: 'get',
//         params: params
//     });
// }
export function getcourseList(data) { // 习题列表
    return request({
        url: '/backend/exerciseQuestion/getList',
        method: 'post',
        data: data
    })
}

export function createUpdateName(data) { // 创建/编辑习题名称
    return request({
        url: '/backend/exerciseQuestion/createUpdateName',
        method: 'post',
        data: data
    })
}

export function answerList(params) { // 获取答题用户列表接口
    return request({
        url: '/backend/exerciseQuestion/answer-result/list',
        method: 'get',
        params: params
    })
}

export function questionInfo(data) { // 获取题目信息
    return request({
        url: '/backend/exerciseQuestion/questionInfo',
        method: 'post',
        data: data
    })
}

export function questionStore(data) { // 上传题目信息、保存
    return request({
        url: '/backend/exerciseQuestion/questionStore',
        method: 'post',
        data: data
    })
}
export function setUpDown(data) { // 上下架
    return request({
        url: '/backend/exerciseQuestion/setUpDown',
        method: 'post',
        data: data
    })
}

export function resultInfo(params) { // 查看答卷
    return request({
        url: '/backend/exerciseQuestion/answer-result/info',
        method: 'get',
        params: params
    })
}

export function questionCopy(data) { // 上下架
    return request({
        url: '/backend/exerciseQuestion/question/copy',
        method: 'post',
        data: data
    })
}